export const DUTCH_LOCALE = 'nl-NL';
export const PolicyTermsEnum = {
  QL_MLB: 'Quantum Leben',
  IPT_MLB: 'iptiQ',
  UNKNOWN: 'Unknown Policy',
};
export const SERVER_ERROR = 'Een berekening is op dit moment helaas niet mogelijk. Probeer het later nog een keer';
